import { css } from "@emotion/react";
import { bpoints } from "../../../../Utils/breakpoints";

export const congratulationsCSS = () => css`
width: 100%;
    .TopText {
        color: #29588C;
        text-align: center;
        font-family: 'Neue Haas Grotesk Display Pro';
        font-size: calc(0.6rem + 1.4vw);
        font-style: normal;
        font-weight: 600;
        line-height: 105.405%;
        width: 60%;
        margin-top: 3.5rem;
        margin-bottom: 1rem;

        @media (max-width: ${bpoints.mobile.w}px) {
            width: 100%;
            padding: 0 8vw;
            font-size: calc(1.4rem + 1.2vw);
        }
    }

    .TextContainer {
        display: flex;
        flex-direction: column;
        z-index: 1;
        text-align: center;
        font-size: calc(10px + 1vw);
        background: #204b7b;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        @media (max-width: ${bpoints.mobile.w}px) {
            padding: 0 10%;
            font-size: calc(16px + 1vw);

            span {
                display: contents;
            }
        }
    }

    .ExtraInfo {
        font-size: calc(16px + (18 - 16) * ((100vw - 320px) / (1920 - 320)));
        color: #888;
        margin-left: 5px;
    }

    .ContainetBtn {
        width: 100%;
        align-items: center;
    }

    .ButtonSection2 {
        margin: 19vh auto;
        display: flex;
        flex-direction: column;
        gap: 5.2vh;
        align-items: center;
        width: 100%;

        .ButtonRow {
            width: calc(9rem + 28vw);
            display: flex;
            gap: calc(2rem + 1vw);
            color: white;
            font-weight: 500;
            font-size: calc(1.1rem + 0.6vw);
            letter-spacing: 0.74px;
            justify-content: center;

            @media (max-width: ${bpoints.mobile.w}px) {
                flex-direction: column;
                gap: 15px;
                font-size: calc(1.3rem + 1.5vw);
                width: 70%;
            }

            .Green {
                background-color: #22ec9a;
                :hover {
                    background-color: #2ad690;
                }
            }

            .Blue {
                background-color: #32b8df;
            }
        }

        .Shadow {
            margin-top: -1rem;
            border-radius: 837px;
            background: radial-gradient(
                50.94% 44.66% at 49.86% 50.14%,
                rgba(0, 0, 0, 0.12) 0%,
                rgba(217, 217, 217, 0) 100%
            );
            width: calc(9rem + 28vw);
            height: 3rem;
        }
    }


`;
